/**
Author - Venkatesh Pullaganti
Git - https://github.com/venkatesh1146
**/

import React, {useState, useEffect} from 'react';

import {PropTypes} from 'prop-types';

import UploadDocument from './UploadDocument';

const propTypes = {
  onSubmitDocument: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  documentOptions: PropTypes.array,
  errorMessage: PropTypes.string,
  instructions: PropTypes.string,
  extrasFormAppender: PropTypes.func,
  prependContent: PropTypes.node,
  isBtnDisabled: PropTypes.bool,
  showUploadSection: PropTypes.bool,
  isFileRequired: PropTypes.bool,
  referenceImage: PropTypes.string,
  successStyleOnUpload: PropTypes.bool,
};

const UploadDocumentContainer = ({
  onSubmitDocument,
  isLoading,
  heading,
  subHeading,
  documentOptions,
  errorMessage,
  uploadMessage,
  goBackButton,
  instructions,
  extrasFormAppender,
  prependContent,
  isBtnDisabled = false,
  showUploadSection = true,
  isFileRequired = true,
  referenceImage,
  successStyleOnUpload = false,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showAnimation, setShowAnimation] = useState(false);
  const [binaryImage, setBinaryImage] = useState(null);

  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedOption, setSelectedOption] = useState(
    documentOptions && documentOptions.length ? documentOptions[0] : null
  );
  const [password, setPassword] = useState(null);

  useEffect(() => {
    if (documentOptions && documentOptions.length) {
      setSelectedOption(documentOptions[0]);
    }
  }, []);

  useEffect(() => {
    if (!isFileRequired) {
      setIsDisabled(false);
      return;
    }
    setIsDisabled(!(binaryImage?.name?.length > 0));
  }, [binaryImage, isFileRequired]);

  const startAnimation = () => {
    setShowAnimation(true);
    setTimeout(() => {
      setShowAnimation(false);
    }, 1200);
  };

  const handleDeleteUploadedFile = (file) => {
    const filteredList = uploadedFiles.filter((eachFile) => eachFile.id !== file.id);
    setUploadedFiles(filteredList);
    setBinaryImage(null);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    if (binaryImage !== null) {
      formData.append('doc_file', binaryImage, binaryImage.name);
    }
    if (password && password.length) {
      formData.append('doc_pass', password);
    }
    if (extrasFormAppender) {
      extrasFormAppender(formData, selectedOption);
    }
    onSubmitDocument(formData, selectedOption?.key);
  };

  const handleImageUpload = (files) => {
    const uploadedFiles = [];

    files.forEach((eachFile, index) => {
      eachFile.id = index;
      uploadedFiles.push(eachFile);
    });

    let isLimitExceeded = false;

    if (!isLimitExceeded) {
      const fileImage = files[0];
      setBinaryImage(fileImage);

      setUploadedFiles(uploadedFiles);
      startAnimation();
    }
  };

  return (
    <UploadDocument
      handleImageUpload={handleImageUpload}
      handleDeleteUploadedFile={handleDeleteUploadedFile}
      isDisabled={isDisabled || isBtnDisabled}
      isLoading={isLoading}
      uploadedFiles={uploadedFiles}
      showAnimation={showAnimation}
      onSubmit={onSubmit}
      heading={heading}
      subHeading={subHeading}
      documentOptions={documentOptions}
      allowPasswordProtected
      setSelectedOption={setSelectedOption}
      selectedOption={selectedOption}
      password={password}
      setPassword={setPassword}
      errorMessage={errorMessage}
      uploadMessage={uploadMessage}
      goBackButton={goBackButton}
      instructions={instructions}
      prependContent={prependContent}
      showUploadSection={showUploadSection}
      referenceImage={referenceImage}
      successStyleOnUpload={successStyleOnUpload}
    />
  );
};

UploadDocumentContainer.prototype = propTypes;

export default UploadDocumentContainer;
